import {
  LocalizationProvider,
  type LocalizationProviderProps,
} from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { useMemo } from 'react'

import { getPickerLocaleText } from './getPickerLocaleText'

type AppLocalizationProviderProps = Omit<
  LocalizationProviderProps<string>,
  'dateAdapter'
> & {
  adapterLocale: string
}

export const AppLocalizationProvider = ({
  adapterLocale,
  localeText,
  ...props
}: AppLocalizationProviderProps) => {
  const mergedLocaleText = useMemo(
    () => ({ ...getPickerLocaleText(adapterLocale), ...localeText }),
    [adapterLocale, localeText],
  )

  return (
    <LocalizationProvider
      {...props}
      dateAdapter={AdapterLuxon}
      adapterLocale={adapterLocale}
      localeText={mergedLocaleText}
    />
  )
}
